import React from "react";
import PropTypes from "prop-types";
import { FaBug, FaTasks, FaLightbulb, FaBookOpen, FaBolt } from "react-icons/fa";

const TYPE_CONFIG = {
  bug:          { Icon: FaBug,       color: "#EF4444" },
  "user-story": { Icon: FaBookOpen,  color: "#3B82F6" },
  userstory:    { Icon: FaBookOpen,  color: "#3B82F6" },
  "user story": { Icon: FaBookOpen,  color: "#3B82F6" },
  feature:      { Icon: FaLightbulb, color: "#F59E0B" },
  task:         { Icon: FaTasks,     color: "#10B981" },
  epic:         { Icon: FaBolt,      color: "#8B5CF6" },
};

const WorkItemIcon = ({ type, size = 13 }) => {
  const key = (type || "").toLowerCase().trim();
  const config = TYPE_CONFIG[key] || TYPE_CONFIG["task"];
  const { Icon, color } = config;
  return <Icon size={size} color={color} />;
};

WorkItemIcon.propTypes = {
  type: PropTypes.string,
  size: PropTypes.number,
};

export default WorkItemIcon;